import { Component, Input } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { SettingsService } from '../../../core/settings.service';
import { DialogService } from '../../../utils/dialog/dialog.service';
import { BookWorkshopTermsNConditionsOverlayComponent } from './book-workshop-terms-n-conditions-overlay-view.component.ts/book-workshop-terms-n-conditions-overlay.component';

@Component({
    selector: 'app-book-workshop-terms-n-conditions',
    template: `
        <div
            class="flow__form-checkbox-area"
            [ngClass]="{ 'state state--alert': inputControl?.errors && inputControl?.touched }"
            *ngIf="settingsService.get() | async as ss"
        >
            <app-checkbox [parentForm]="parentForm" [controlName]="controlName"></app-checkbox>
            <p class="no-margin text-small">
                <label [for]="controlName">
                    {{ ss.bookWorkshopTermsNConditions.checkboxText }}
                </label>
                <span class="link" (click)="handleClick()">{{ ss.bookWorkshopTermsNConditions.checkboxLinkText }}</span>
            </p>
        </div>
    `,
})
export class BookWorkshopTermsNConditionsComponent {
    @Input() parentForm: UntypedFormGroup;
    @Input() controlName: string;
    constructor(public settingsService: SettingsService, private dialogService: DialogService) {}
    handleClick() {
        this.dialogService.openSidePanelWithComponent(BookWorkshopTermsNConditionsOverlayComponent);
    }

    get inputControl() {
        return this.parentForm?.get(this.controlName);
    }
}
